import {Forms} from "@types/FormTypes";
import {__} from "@wordpress/i18n";
import {validations} from "./Validations";
import {CI_FREQUENCY_OPTIONS, CI_LABELS, CI_TOOLTIPS} from "./FormConfig.tsx";

/**
 * API endpoint and configuration for simulation submission.
 */
const API_BASE_URL = `${window.location.origin}/wp-json/simulators/v1/retirement-investment`;
const PROCESS_TYPE = 1;
const OPERATION_TYPE = 1;


/**
 * Simulator custom URL - Check if exists some custom URL for this block
 * [==START==]
 */
let MIDDLEWARE_API_URL = API_BASE_URL;
const rootElement = document.querySelector('[data-block="tool-block"]') as HTMLElement | null;
if ( rootElement !== null ) {
  const NEW_URL = rootElement.getAttribute('data-tool-managment');
  if ( NEW_URL !== null && NEW_URL !== '' ) {
    MIDDLEWARE_API_URL = NEW_URL;
  }
}
/* [==END==] */


/**
 * Form definition for the Retirement Investment simulator.
 *
 * Includes:
 * - Field configuration (labels, types, options)
 * - Field-level conditions
 * - Tooltips
 * - API integration details
 * - Yup validation schema reference
 */
export const forms: Forms = {
  retirement_investment: {
    validation: validations.retirement_investment,

    api: {
      url: MIDDLEWARE_API_URL,
      processType: PROCESS_TYPE,
      operationType: OPERATION_TYPE,
    },

    fields: [
      {
        type: "title",
        name: "simulation_data_title",
        label: __("Dados da simulação", "df-simulators"),
      },

      {
        type: "group",
        group_fields: [
          {
            type: "heading",
            name: "goal_amount_heading",
            label: CI_LABELS.goalAmount
          },
          {
            type: "number",
            label: __("Objetivo de poupança", "df-simulators"),
            name: "goal_amount",
            icon: "currency",
            placeholder: "5.000",
            tooltip: {
              title: CI_LABELS.goalAmount,
              content: CI_TOOLTIPS.goalAmount
            }
          },
        ]
      },
      {
        type: "group",
        group_fields: [{
          type: "heading",
          name: "initial_investment_heading",
          label: CI_LABELS.initialInvestment,
        },
          {
            type: "number",
            name: "initial_investment",
            label: __("Capital inicial", "df-simulators"),
            icon: "currency",
            placeholder: "0",
          },
        ]
      },
      {
        type: "group",
        group_fields: [{
          type: "heading",
          name: "total_years_heading",
          label: CI_LABELS.totalYears
        },
          {
            type: "number",
            label: __("Anos", "df-simulators"),
            name: "investment_period_years",
            placeholder: "10",
            tooltip: {
              title: CI_LABELS.totalYears,
              content: CI_TOOLTIPS.totalYears
            }
          },
        ]
      },
      {
        type: "group",
        group_fields: [{
          type: "heading",
          name: "return_rate_heading",
          label: CI_LABELS.returnInterestRate,
          tooltip: {
            title: CI_LABELS.returnInterestRate,
            content: CI_TOOLTIPS.returnInterestRate
          }
        },
          {
            type: "number",
            name: "return_rate",
            icon: "percentage",
            placeholder: "2,50",
            defaultValue: 2.50
          },
        ]
      },
      {
        type: "group",
        group_fields: [
          {
            type: "heading",
            name: "compound_interest_heading",
            label: CI_LABELS.haveCompoundInterest,
            tooltip: {
              title: CI_LABELS.haveCompoundInterest,
              content: CI_TOOLTIPS.haveCompoundInterest
            }
          },
          {
            type: "radio",
            name: "have_compound_interest",
            layout: "horizontal",
            options: [
              { value: "true", label: __("Sim", "df-simulators") },
              { value: "false", label: __("Não", "df-simulators") },
            ],
            defaultValue: "true"
          }
        ]
      },
      {
        type: "group",
        condition: {
          field: "have_compound_interest",
          value: "true"
        },
        group_fields: [
          {
            type: "heading",
            name: "capitalization_frequency_heading",
            label: CI_LABELS.capitalizationFrequency
          },
          {
            type: "select",
            name: "capitalization_frequency",
            options: CI_FREQUENCY_OPTIONS.capitalization_frequency,
            defaultValue: "monthly"
          }
        ]
      }
    ],
  },
};
